import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=3f373fa0&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=3f373fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f373fa0",
  null
  
)

export default component.exports